import { useState } from 'react';
import { useImmutableCallback } from '@agro1desenvolvimento/react-hooks';
import { AlertasTalhaoService } from '../../../services';
import type { TalhaoAlerta } from '../../../services/alertas-talhao';
import Agro1Toast from '../../../components/Agro1Toast';

type UseAlertasTalhaoReturn = {
  alertasTalhoes: TalhaoAlerta[];
  alertasLoading: boolean;
  alertasError: boolean;
  loadAlertas: (propriedadeId: number) => void;
};

const useAlertasTalhao = (): UseAlertasTalhaoReturn => {
  const [alertasTalhoes, setAlertasTalhoes] = useState<TalhaoAlerta[]>([]);
  const [alertasLoading, setAlertasLoading] = useState(false);
  const [alertasError, setAlertasError] = useState(false);

  const loadAlertas = useImmutableCallback((propriedadeId: number) => {
    setAlertasTalhoes([]);
    setAlertasError(false);
    setAlertasLoading(true);
    AlertasTalhaoService.byPropriedade(propriedadeId)
      .then(setAlertasTalhoes)
      .catch((err) => {
        console.error('[alertas-talhao] falha ao carregar:', err);
        setAlertasError(true);
        Agro1Toast.show({
          detail:
            'Não foi possível carregar os alertas dos talhões. Tente novamente.',
          severity: 'warn',
        });
      })
      .finally(() => setAlertasLoading(false));
  });

  return { alertasTalhoes, alertasLoading, alertasError, loadAlertas };
};

export default useAlertasTalhao;
